import React from 'react';

import WhiteboxPage from '../../../components/WhiteboxPage';
import { useButtonClickedEvent } from '../../../utilities/analytics/analytics-web-client';
import { useRecaptchaChallengeObserver } from '../../../utilities/hooks';
import { useCreateAccountConfirmationPageState } from '../../../hooks';
import { CreateAccountConfirmationPrivacyPolicy } from './components/CreateAccountConfirmationPrivacyPolicy';
import { fetchPageState } from '../../../utilities/fetch-api';

import ConfirmationForm from './components/ConfirmationForm';
import { CREATE_ACCOUNT_CONFIRMATION_PAGE_ID as pageId } from './constants';
import { Header } from './components/Header';
import { TitleText } from './components/styled';
import { WhiteboxFooter } from './components/Footer';
import { ConfirmationFormTitleText } from './components/ConfirmationFormTitleText';

export async function socialConfirmationLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/login/social/confirmation/state', request, {
    capabilities: ['capability-group--login', 'capability-subgroup--social-login'],
  });
}

export const CreateAccountConfirmationPage = () => {
  const pageState = useCreateAccountConfirmationPageState();

  const { createNeeded, isEmbedded, isLoading, loginType, oidcContext, verifyNeeded } = pageState;

  // TODO: move to our recaptcha component for this page?
  useRecaptchaChallengeObserver(pageId);

  const onSubmitClick = useButtonClickedEvent(pageId, 'confirmationSignup');

  return (
    <WhiteboxPage
      pageId={pageId}
      header={<Header createNeeded={createNeeded} />}
      whiteboxFooter={
        <WhiteboxFooter
          loginType={loginType}
          verifyNeeded={verifyNeeded}
          createNeeded={createNeeded}
          isEmbedded={isEmbedded}
          oidcContext={oidcContext}
        />
      }>
      <ConfirmationForm
        isEmbedded={isEmbedded}
        isLoading={isLoading}
        privacyPolicy={<CreateAccountConfirmationPrivacyPolicy />}
        onSubmitClick={onSubmitClick}
        title={
          <TitleText>
            <ConfirmationFormTitleText loginType={loginType} createNeeded={createNeeded} />
          </TitleText>
        }
      />
    </WhiteboxPage>
  );
};

export default CreateAccountConfirmationPage;
